module.exports = __webpack_public_path__ + "d4c891a805cf75b6445a6616c07256e0.pdf";